import { createAxiosCancelable } from '@hmhco/core-network/src/axiosHelpers';
import requestHelper from '@hmhco/core-network/src/utils/requestHelper';
import { getIdentifiedPlatformConfig } from '@hmhco/login-config';

const forgotPasswordUrl = `/user/forgotPassword`;
const forgotPasswordUrlHnm = `/user/forgotPassword`;
const forgotPasswordUrlNwea = `/user/forgotPassword`;
const forgotPasswordUrlAitools = `/user/forgotPassword`;
const forgotPasswordUrlWritable = `/user/forgotPassword`;

export default (pactConfig = {}) => {
  const { client, cancel, cancelToken, isCancel } = createAxiosCancelable({
    includeAuth: false,
  });
  const request = requestHelper({
    client,
    cancelToken,
    isCancel,
    baseURL: getIdentifiedPlatformConfig().authorizationApi,
    pactConfig,
  });
  return {
    forgotPassword: ({ username, districtId, orgRefId }) =>
      request.post(
        forgotPasswordUrl,
        JSON.stringify({ username, districtId, platform: 'Ed', orgRefId }),
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      ),
    cancel,
    forgotPasswordHnm: ({ username, districtId, orgRefId }) =>
      request.post(
        forgotPasswordUrlHnm,
        JSON.stringify({
          username,
          districtId,
          platformId: 'flight',
          orgRefId,
        }),
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      ),
    forgotPasswordNwea: ({ username, districtId, orgRefId }) =>
      request.post(
        forgotPasswordUrlNwea,
        JSON.stringify({ username, districtId, platformId: 'nwea', orgRefId }),
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      ),
    forgotPasswordAitools: ({ username, districtId, orgRefId }) =>
      request.post(
        forgotPasswordUrlAitools,
        JSON.stringify({
          username,
          districtId,
          platformId: 'Aitools',
          orgRefId,
        }),
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      ),
    forgotPasswordWritable: ({ username, districtId, orgRefId }) =>
      request.post(
        forgotPasswordUrlWritable,
        JSON.stringify({
          username,
          districtId,
          platformId: 'writable',
          orgRefId,
        }),
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      ),
  };
};
